import { useEffect } from 'react';
import AppRouter from './routes/AppRouter'
import { AuthProvider } from './context/AuthContext';
import ImpersonationBanner from './components/admin/ImpersonationBanner';
import { MySchoolProvider } from './context/MySchoolContext';
import { NotificationProvider } from './context/NotificationContext';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useTheme } from './context/ThemeContext';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";

function App() {
  const { i18n } = useTranslation();
  const { isDark } = useTheme();
  const isArabic = i18n.language?.startsWith('ar');
  const isRtl = Boolean(isArabic);

  // Sync document direction with language
  useEffect(() => {
    document.documentElement.dir = isArabic ? 'rtl' : 'ltr';
    document.documentElement.lang = isArabic ? 'ar' : 'en';
    
    // Update document title dynamically based on language and environment
    document.title = isArabic 
      ? (import.meta.env.VITE_APP_NAME_AR || 'أبجد')
      : (import.meta.env.VITE_APP_NAME_EN || 'abjd');
    
    toast.dismiss();
  }, [i18n.language, isArabic]);

  return (
    <AuthProvider>
      <ImpersonationBanner />
      <MySchoolProvider>
        <NotificationProvider>
          <AppRouter />
          <ToastContainer
            key={i18n.language}
            position={isRtl ? "top-left" : "top-right"}
            rtl={isRtl}
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={isDark ? "dark" : "light"}
            style={{ zIndex: 99999 }}
          />
        </NotificationProvider>
      </MySchoolProvider>
    </AuthProvider>
  );
}

export default App;
